import { Moon } from 'lucide-react';

export const HeaderBrand = () => (
<div className="flex items-center space-x-3">
              <div className="relative">
                <Moon className="w-10 h-10 text-red-600" />
                <div className="absolute inset-0 blur-lg bg-red-600 opacity-30 animate-pulse"></div>
              </div>
              <div>
                <span className="block text-base md:text-lg font-bold text-red-600 leading-tight">
                  Marabout Africain Retour Affectif Rapide
                </span>
                <span className="hidden md:block text-xs text-gray-400 font-medium">
                  Guadeloupe • Sorcier Vaudou • Voyant Médium
                </span>
              </div>
            </div>
);
